/*
 * @Author: masonzhou
 * @Date: 2024-01-19 09:15:56
 * @LastEditTime: 2024-02-02 15:01:33
 * @FilePath: \yl-cjsph-tms-operation-front\src\api\user.js
 * @Description:
 */
import request from '@/utils/request';
import { GATEWAY } from '@/utils/const';

/** 登录 */
export function getLogin(data) {
  return request({
    url: `${GATEWAY.CJS}/system/auth/login`,
    method: 'post',
    data
  });
}

/** 获取用户信息 */
export function getInfo(query) {
  return request({
    url: `${GATEWAY.CJS}/system/auth/userInfo`,
    method: 'get',
    params: query
  });
}

// 修改密码
export function updateUserPwd(data) {
  return request({
    url: `${GATEWAY.CJS}/system/user/updatePassword`,
    method: 'post',
    data
  });
}

